import { useEffect, useState } from "react";
import { Box, Container, CssBaseline } from "@mui/material";
import { VerifyYourAccount } from "./components/VerifyYourAccount";
import { EmailVerificationForm } from "./email/EmailVerificationForm";
import { SMSVerificationForm } from "./sms/SMSVerificationForm";
import { CongratulationsScreen } from "../components/Congratulations";
import { VERIFICATION_STEPS } from "./constants/verification.constant";
import { useCheckActivationToken } from "./hooks/useCheckVerificationToken";
import { useTwoFa } from "./hooks/useTwoFa";

export const AccountVerification = () => {
  const { isValid, maskedUser } = useCheckActivationToken();
  const [currentStep, setCurrentStep] = useState(VERIFICATION_STEPS.CHOOSE_METHOD);
  const [isVisible, setIsVisible] = useState(false);

  const { sendTwoFa } = useTwoFa();

  //Animacion de entrada
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 200);
    return () => clearTimeout(timeout);
  }, []);

  //Error de token invalido
  if (!isValid) {
    return <Box> Invalid activation token </Box>;
  }

  const handleMethodSelect = (method) => {
    if (method === "email") {
      setCurrentStep(VERIFICATION_STEPS.EMAIL_VERIFICATION);
      sendTwoFa("email");
    } else if (method === "phone") {
      setCurrentStep(VERIFICATION_STEPS.SMS_VERIFICATION);
      sendTwoFa("phone");
    }
  };

  const handleBackToMethodSelection = () => {
    setCurrentStep(VERIFICATION_STEPS.CHOOSE_METHOD);
  };

  const handleVerificationSuccess = () => {
    setCurrentStep(VERIFICATION_STEPS.SUCCESS);
    localStorage.removeItem("pendingActivationAccount");
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case VERIFICATION_STEPS.CHOOSE_METHOD:
        return <VerifyYourAccount onMethodSelect={handleMethodSelect} />;

      case VERIFICATION_STEPS.EMAIL_VERIFICATION:
        return <EmailVerificationForm email={maskedUser?.email} onBack={handleBackToMethodSelection} onSuccess={handleVerificationSuccess} />;

      case VERIFICATION_STEPS.SMS_VERIFICATION:
        return <SMSVerificationForm phone={maskedUser?.phone} onBack={handleBackToMethodSelection} onSuccess={handleVerificationSuccess} />;

      case VERIFICATION_STEPS.SUCCESS:
        return <CongratulationsScreen />;

      default:
        return null;
    }
  };

  return (
    <Container component="main" maxWidth="lg">
      <CssBaseline />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          opacity: isVisible ? 1 : 0,
          transition: "opacity 0.5s",
        }}
      >
        {renderCurrentStep()}
      </Box>
    </Container>
  );
};
